import React, { useEffect, useState, } from 'react'
import { useParams } from 'react-router';
import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';

import {
    checkIfCallPrinterAsync, responseGet, globalSettings, separatorsNumbersSet, styles, sendMessageCloseCurrentWindowAsync,
    dateTimeFormatGlobalSet, statusByNumberGet, awaitDelay, isUndNullEmp, languageObjGet, LoadingSection,
} from '../../helpers/settings';
//import CssfxLoading from '../main/CssfxLoading';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'ElectionResultsPrint';

export default function ElectionResultsPrint({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region others
    let result;
    let headers = {};
    let dataObj = {};
    const { id, } = useParams();
    const auth = useAuth();
    const [showLoading, setShowLoading] = useState(true);
    const [dataGlobal, setDataGlobal] = useState({ apartmentTotals: 0, apartmentVotesPercentage: 0.00, apartmentVotesPercentageHtml: '', isResumen: false, });
    //#endregion others

    //#region building
    const [building, setBuilding] = useState({});
    //#endregion building

    //#region election
    const [election, setElection] = useState({});
    //const [isResumen, setIsResumen] = useState(false);
    //#endregion election

    //#region election (details)
    const [electionDetails, setElectionDetails] = useState([]);
    //#endregion election (details)

    //#region user
    const [user, setUser] = useState({});
    //#endregion user

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.fourthySeconds, false, true, null, '');

            //#region get condominium board election
            headers = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlReports}/${id}`,
            };

            result = await axios?.get(dataObj?.url, headers);
            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const electionLocal = response?.result;
            setElectionDetails(electionLocal?.details);

            //setIsResumen(!isUndefined(localElection.isResumen) && !isNull(localElection.isResumen) ? localElection.isResumen : false);
            const apartmentVotesPercentage = !isUndNullEmp({ data: electionLocal?.apartmentVotesPercentage, subMethod: currentMethod, })?.result ? electionLocal?.apartmentVotesPercentage : 0.00;
            response = await votesPercentageGetAsync({
                apartmentVotesPercentage: apartmentVotesPercentage,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setDataGlobal({
                apartmentTotals: (!isUndNullEmp({ data: electionLocal?.apartmentTotals, subMethod: currentMethod, })?.result ? electionLocal?.apartmentTotals : 0),
                //apartmentVotesPercentage: (!isUndefined(localElection.apartmentVotesPercentage) && !isNull(localElection.apartmentVotesPercentage) ? localElection.apartmentVotesPercentage : 0.00),
                apartmentVotesPercentage: apartmentVotesPercentage,
                apartmentVotesPercentageHtml: response?.result,
                isResumen: (!isUndNullEmp({ data: electionLocal?.isResumen, subMethod: currentMethod, })?.result ? electionLocal.isResumen : false),
            });
            //#endregion get condominium board election

            //#region get elections
            setElection(electionLocal?.condominiumBoardElection);
            //#endregion get election

            //#region building get
            setBuilding(electionLocal?.building);
            //#endregion building get

            //#region user get
            setUser(electionLocal?.user);
            //#endregion building get

            //#region show printer promp
            response = await checkIfCallPrinterAsync({ checkIfOnlyIsMobile: false, subMethod: currentMethod, });
            if (!response.isSuccess) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            const sHowPrinterPromp = response?.result === true ? true : false;

            setShowLoading(false);

            //sendMessage(-2, '', 0, false, false, null, '');
            if (sHowPrinterPromp) {
                //await new Promise(r => setTimeout(r, globalSettings?.timers?.oneSecond));
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                window?.addEventListener('load', window?.print());
            }
            //#endregion show printer promp
        } catch (ex) {
            setShowLoading(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: true,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return response;
        }
    }

    const dataDetailGet = ({ processType = 0, detail = {}, subMethod = '', }) => {
        const currentMethod = 'dataDetailGet';
        let response = responseGet();
        try {
            switch (processType) {
                case 0:
                    response.result = detail?.id;
                    break;
                case 1:
                    response.result = detail?.userFullName;
                    break;
                case 2:
                    response.result = detail?.apartmentUser?.apartment?.identifier;
                    break;
                case 3:
                    response.result = detail?.votesResults?.votes === 0 ? '' : detail?.votesResults?.votes;
                    break;
                case 4:
                    response.result = detail?.condominiumBoardRole?.description;
                    break;
                case 5:
                    //#region old code
                    //response.result = detail?.votesResults.votesPercentage;
                    //#endregion old code
                    response.result = !isUndNullEmp({ data: detail?.votesResults?.votesPercentage, subMethod: currentMethod, })?.result && detail?.votesResults?.votesPercentage > 0 ?
                        detail?.votesResults?.votesPercentage : null;
                    break;
                case 6:
                    //#region old code
                    //response.result = detail?.votesResults.votesPercentage;
                    //#endregion old code
                    response.result = !isUndNullEmp({ data: detail?.votesResults?.votesPercentage, subMethod: currentMethod, })?.result ? detail?.votesResults?.votesPercentage : 0;
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
            //sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
        }
        return response;
    }

    const votesPercentageGetAsync = async ({ apartmentVotesPercentage = 0.00, subMethod = '', }) => {
        const currentMethod = 'votesPercentageGetAsync';
        let response = responseGet();
        try {
            //#region variables
            const percentage = separatorsNumbersSet({ number: apartmentVotesPercentage, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result;
            //#endregion variables

            //#region process
            if (apartmentVotesPercentage > 0.00 && apartmentVotesPercentage < 50.00) {
                //response.result = `<span class='text-danger'><b>${separatorsNumbersSet({ number: apartmentVotesPercentage, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result}%</b>`;
                response.result = `<span class='text-danger'><b>${percentage}%</b>`;
                response.result += `${globalSettings?.html?.space?.formatTwo}<i class='${globalSettings?.icons?.caretDown}'></i>`;
                response.result += `</span>`
            } else if (apartmentVotesPercentage >= 50.00 && apartmentVotesPercentage < 75.00) {
                //response.result = `<span class='text-warning'><b>${separatorsNumbersSet({ number: apartmentVotesPercentage, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result}%</b>`;
                response.result = `<span class='text-warning'><b>${percentage}%</b>`;
                response.result += `${globalSettings?.html?.space?.formatTwo}<i class='${globalSettings?.icons?.notEqual}'></i>`;
                response.result += `</span>`
            } else if (apartmentVotesPercentage >= 75.00) {
                //response.result = `<span class='text-success'><b>${separatorsNumbersSet({ number: apartmentVotesPercentage, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result}%</b>`;
                response.result = `<span class='text-success'><b>${percentage}%</b>`;
                response.result += `${globalSettings?.html?.space?.formatTwo}<i class='${globalSettings?.icons?.caretUp}'></i>`;
                response.result += `</span>`
            }
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: `onLoad - form`, });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            {/* <div style={{margin: '3px'}}> */}
            {//showReport && !showLoading ?
                !showLoading ?
                    <div className='container mt-4'>
                        <div className='card card-outline card-secondary elevation-3 shadow-lg'>
                            <div className='card-header'>

                                <h5 className='card-title'>
                                    <img src={globalSettings?.images?.appLogo}
                                        alt='appLogo'
                                        className='brand-image img-circle elevation-3'
                                        style={styles?.receiptPrintLogo} /> {globalSettings?.app?.name}

                                    <div className='text-muted' style={{ fontSize: '13px' }}>
                                        {HtmlParser(globalSettings?.html?.space?.formatSevenTeen)}{globalSettings?.messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageObj?.id]}
                                    </div>
                                </h5>

                                <div className='card-tools text-small'>
                                    <ul className='list-unstyled float-right'>
                                        <li>
                                            {`${globalSettings?.labels?.date?.[languageObj?.id]}:`} <b>{`${dateTimeFormatGlobalSet({
                                                date: new Date(),
                                                type: languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: false,
                                                languageId: languageObj?.id,
                                                subMethod: currentMethod,
                                            })?.result}`}</b>
                                        </li>
                                        <li>
                                            {`${globalSettings?.labels?.time?.[languageObj?.id]}:`} <b>{`${dateTimeFormatGlobalSet({
                                                date: new Date(),
                                                type: '',
                                                format: languageObj?.format?.time?.type,
                                                addTime: false,
                                                languageId: languageObj,
                                                subMethod: currentMethod,
                                            })?.result}`}</b>
                                        </li>
                                        <li>
                                            {`${globalSettings?.labels?.user?.[languageObj?.id]}:`} <b>{!isUndNullEmp({ data: user?.displayName, subMethod: currentMethod, })?.result ?
                                                user?.displayName : `${user?.firstName || ''} ${user?.lastName || ''}`}</b>
                                        </li>
                                    </ul>
                                </div>

                            </div>

                            <div className='card-body'>

                                {/* <div className='row'> */}
                                <div className='text-center'>
                                    {/* <h5>{globalSettings?.labels?.condominiumBoardElections?.[languageObj?.id]}</h5> */}
                                    {/* <b>({globalSettings?.labels?.previousResults?.[languageObj?.id]})</b> */}
                                    {/* <h5><b>({globalSettings?.labels?.previousResults?.[languageObj?.id]})</b></h5> */}
                                    {/* {isResumen ? <h5><b>({globalSettings?.labels?.previousResults?.[languageObj?.id]})</b></h5> : ''} */}
                                    {/* <h5><b>({dataGlobal.isResumen ? globalSettings?.labels?.previousResults?.[languageObj?.id] : globalSettings?.labels?.finalResults?.[languageObj?.id]})</b></h5> */}
                                    {/* <h5><b>({dataGlobal.isResumen ?
                                        globalSettings?.labels?.previousResults?.[languageObj?.id]?.toLowerCase() :
                                        globalSettings?.labels?.finalResults?.[languageObj?.id]?.toLowerCase()})</b></h5> */}
                                    <h5>
                                        {globalSettings?.labels?.condominiumBoardElections?.[languageObj?.id]} <br />
                                        <b>({dataGlobal.isResumen ?
                                            globalSettings?.labels?.previousResults?.[languageObj?.id]?.toLowerCase() :
                                            globalSettings?.labels?.finalResults?.[languageObj?.id]?.toLowerCase()})</b>
                                    </h5>
                                </div>
                                {/* </div> */}

                                <section className='invoice'>
                                    {/* info row */}
                                    <div className='row invoice-info'>
                                        <div className='col-sm-4 invoice-col'>
                                            <address className='mx-2'>
                                                {globalSettings?.labels?.building?.[languageObj?.id]}: <b>{!isUndNullEmp({ data: building?.description, subMethod: currentMethod, })?.result ? building?.description : ''}</b><br />
                                                {globalSettings?.labels?.phone?.[languageObj?.id]}: {!isUndNullEmp({ data: building?.phoneNumber, subMethod: currentMethod, })?.result ? building?.phoneNumber : ''}<br />
                                                {globalSettings?.labels?.address?.[languageObj?.id]}: {!isUndNullEmp({ data: building?.address, subMethod: currentMethod, })?.result ? building?.address : ''}<br />
                                                {globalSettings?.labels?.email?.[languageObj?.id]}: {!isUndNullEmp({ data: building?.email, subMethod: currentMethod, })?.result ? building?.email : ''}<br />
                                                {globalSettings?.labels?.apartments?.[languageObj?.id]}: <b>{!isUndNullEmp({ data: dataGlobal?.apartmentTotals, subMethod: currentMethod, })?.result ? separatorsNumbersSet({ number: dataGlobal?.apartmentTotals, withDecimals: false, consoleLogErrorShow: true, subMethod: currentMethod, })?.result : 0}</b><br />
                                            </address>
                                        </div>
                                        {/* /.col */}
                                        <div className='col-sm-4 invoice-col border-left'>
                                            <address>
                                                {globalSettings?.labels?.description?.[languageObj?.id]}: <b>{!isUndNullEmp({ data: election?.description, subMethod: currentMethod, })?.result ? election?.description : ''}</b><br />
                                                {globalSettings?.labels?.from?.[languageObj?.id]}: <b>{`${dateTimeFormatGlobalSet({
                                                    date: (!isUndNullEmp({ data: election?.startDate, subMethod: currentMethod, })?.result ? election?.startDate : new Date()),
                                                    type: globalSettings?.react?.tempusDominus?.format?.date?.dmy,
                                                    format: 0,
                                                    addTime: true,
                                                    languageId: languageObj?.id,
                                                    subMethod: currentMethod,
                                                })?.result}`}</b><br />
                                                {globalSettings?.labels?.to?.[languageObj?.id]}: <b>{`${dateTimeFormatGlobalSet({
                                                    date: (!isUndNullEmp({ data: election?.endDate, subMethod: currentMethod, })?.result ? election?.endDate : new Date()),
                                                    type: globalSettings?.react?.tempusDominus?.format?.date?.dmy,
                                                    format: 0,
                                                    addTime: true,
                                                    languageId: languageObj?.id,
                                                    subMethod: currentMethod,
                                                })?.result}`}</b><br />
                                                {/* {globalSettings?.labels?.status?.[languageObj?.id]}: <b>{!isUndNullEmp({ data: election?.status })?.result ? statusByNumberGet({ status: election?.status, languageId: languageObj?.id, subMethod: currentMethod, })?.result : ''}</b><br /> */}
                                                {globalSettings?.labels?.status?.[languageObj?.id]}: <b>{statusByNumberGet({
                                                    status: election?.status || '',
                                                    languageId: languageObj?.id,
                                                    subMethod: currentMethod,
                                                })?.result}</b><br />
                                                {dataGlobal.isResumen ?
                                                    <>
                                                        {globalSettings?.labels?.voteTwo?.[languageObj?.id]}: <b>
                                                            {!isUndNullEmp({ data: election?.executedVote, subMethod: currentMethod, })?.result && election?.executedVote ?
                                                                <span>
                                                                    <i className={globalSettings?.icons?.award}></i>
                                                                    {HtmlParser(globalSettings?.html?.space?.formatOne)}{globalSettings?.messages?.executed?.[languageObj?.id]}
                                                                </span> :
                                                                <span>
                                                                    <i className={globalSettings?.icons?.fileAltFar}></i>
                                                                    {HtmlParser(globalSettings?.html?.space?.formatOne)}{globalSettings?.messages?.NotExecuted?.[languageObj?.id]}
                                                                </span>
                                                            }</b><br />
                                                        {globalSettings?.labels?.date?.[languageObj?.id]}: <b>{dateTimeFormatGlobalSet({
                                                            date: !isUndNullEmp({ data: election?.executedVoteDate, subMethod: currentMethod, })?.result ? election?.executedVoteDate : new Date()?.toISOString(),
                                                            type: globalSettings?.react?.tempusDominus?.format?.date?.dmy,
                                                            format: 12,
                                                            addTime: false,
                                                            languageId: languageObj?.id,
                                                            subMethod: currentMethod,
                                                        })?.result}</b><br />
                                                    </> :
                                                    <>
                                                        {globalSettings?.labels?.votes?.[languageObj?.id]} vs. {globalSettings?.labels?.apartments?.[languageObj?.id]}: {HtmlParser(dataGlobal.apartmentVotesPercentageHtml)}
                                                    </>
                                                }
                                            </address>
                                        </div>
                                        {/* /.col */}
                                        <div className='col-sm-4 invoice-col border-left'>
                                            {globalSettings?.labels?.remark?.[languageObj?.id]}:<br />
                                            <b>{!isUndNullEmp({ data: election?.remark, subMethod: currentMethod, })?.result ? HtmlParser(election?.remark?.replaceAll('\n', '<br/>')) : ''}</b>
                                        </div>
                                        {/* /.col */}
                                    </div>

                                    {/* /.row */}
                                    {/* Table row */}
                                    <div className='row'>
                                        <div className='col-12 table-responsive'>
                                            <table className='table table-sm table-bordered' style={{ fontSize: '13px' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '25%' }}>{globalSettings?.labels?.name?.[languageObj?.id]}</th>
                                                        <th style={{ width: '10%' }} >{globalSettings?.labels?.apartment?.[languageObj?.id]}</th>
                                                        <th style={{ width: '5%' }} className='text-center'>{globalSettings?.labels?.votes?.[languageObj?.id]}</th>
                                                        <th style={{ width: '65%' }}></th>
                                                    </tr>
                                                </thead>
                                                {/* <tbody> */}
                                                {!isUndNullEmp({ data: electionDetails, subMethod: currentMethod, })?.result && electionDetails?.length > 0 ?
                                                    electionDetails?.map((detail, index) => (
                                                        (index === 0) || (index < electionDetails?.length && detail?.hierarchy !== electionDetails?.[index - 1]?.hierarchy) ?
                                                            // <tbody key={index + 100}>
                                                            <tbody key={dataDetailGet({ processType: 0, detail: detail, subMethod: currentMethod, })?.result}>
                                                                <tr style={{ backgroundColor: '#ddd', fontWeight: 'bold', }}>
                                                                    <th colSpan={4}>{dataDetailGet({ processType: 4, detail: detail, subMethod: 'colSpan={4}', })?.result}</th>
                                                                </tr>
                                                                {/* <tr key={dataDetailGet({ processType: 0, detail: detail, subMethod: currentMethod, })?.result}> */}
                                                                <tr>
                                                                    <td>{HtmlParser(globalSettings?.html?.space?.formatOne)}{dataDetailGet({ processType: 1, detail: detail, subMethod: currentMethod, })?.result}</td>
                                                                    <td>{dataDetailGet({ processType: 2, detail: detail, subMethod: currentMethod, })?.result}</td>
                                                                    <td className='text-center'>{dataDetailGet({ processType: 3, detail: detail, subMethod: currentMethod, })?.result}</td>
                                                                    <td style={{ verticalAlign: 'middle' }}>
                                                                        <div className='progress progress-sm active'>
                                                                            <div className='progress-bar bg-info progress-bar-striped' role='progressbar' aria-valuenow={dataDetailGet({ processType: 5, detail: detail, subMethod: currentMethod, })?.result} aria-valuemin='0' aria-valuemax='100' style={{ width: `${dataDetailGet({ processType: 5, detail: detail, subMethod: currentMethod, })?.result}%` }}>
                                                                                {/* <span className='sr-only'>40% Complete (success)</span> */}
                                                                                <span className=''><b>{dataDetailGet({ processType: 6, detail: detail, subMethod: currentMethod, })?.result}%</b></span>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            :
                                                            // <tr key={dataDetailGet({ processType: 0, detail: detail, subMethod: currentMethod, })?.result}>
                                                            //<tbody key={index + 200}>
                                                            <tbody key={dataDetailGet({ processType: 0, detail: detail, subMethod: currentMethod, })?.result}>
                                                                <tr>
                                                                    <td>{HtmlParser(globalSettings?.html?.space?.formatOne)}{dataDetailGet({ processType: 1, detail: detail, subMethod: currentMethod, })?.result}</td>
                                                                    <td>{dataDetailGet({ processType: 2, detail: detail, subMethod: currentMethod, })?.result}</td>
                                                                    <td className='text-center'>{dataDetailGet({ processType: 3, detail: detail, subMethod: currentMethod, })?.result}</td>
                                                                    <td style={{ verticalAlign: 'middle' }}>
                                                                        <div className='progress progress-sm active'>
                                                                            <div className='progress-bar bg-info progress-bar-striped' role='progressbar' aria-valuenow={dataDetailGet({ processType: 5, detail: detail, subMethod: currentMethod, })?.result} aria-valuemin='0' aria-valuemax='100' style={{ width: `${dataDetailGet({ processType: 5, detail: detail, subMethod: currentMethod, })?.result}%` }}>
                                                                                {/* <span className='sr-only'>40% Complete (success)</span> */}
                                                                                <span className=''><b>{dataDetailGet({ processType: 6, detail: detail, subMethod: currentMethod, })?.result}%</b></span>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>

                                                    ))
                                                    :
                                                    <></>
                                                }
                                                {/* </tbody> */}
                                            </table>
                                        </div>
                                        {/* /.col */}
                                    </div>

                                    <hr />

                                    {/* /.row */}
                                    <div className='row'>
                                        {/* accepted payments column */}
                                        {/* <div className='col-6'>
                                            <p className='lead'>{globalSettings?.labels?.paymentMethods?.[languageObj?.id]}:</p>
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.visaLogo} alt='visa' />
                                            <img className='elevation-3'src={globalSettings?.images?.masterCardLogo} alt='mastercard' />
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.americanExpressLogo} alt='americanExpress' />
                                            <img className='elevation-3'src={globalSettings?.images?.payPalLogo} alt='paypal' />
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.zelleLogo} alt='zelle' />
                                            <img className='elevation-3' src={globalSettings?.images?.bankTransferLogo} alt='bankTranfer' />
                                            <p className='text-muted well well-sm shadow-none' style={{marginTop: 10}}>
                                            </p>
                                        </div> */}
                                        {/* /.col */}
                                        {/* <div className='col-6'>
                                            <p className='lead'></p>
                                            <div className='table-responsive'>
                                                <table className='table table-sm'>
                                                    <tbody><tr>
                                                        <th style={{width: '50%'}}>{globalSettings?.labels?.subTotal?.[languageObj?.id]}:</th>
                                                        <td className='text-right'>{separatorsNumbersSet(apartmentReceipt.total)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{globalSettings?.labels?.tax.es} (0.00%):</th>
                                                        <td className='text-right'>0.00</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Total:</th>
                                                        <td className='text-right'>{apartmentReceipt.total}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> */}
                                        {/* /.col */}

                                        <div className='col-sm-3 col-6'>
                                            <div className='description-block border-right'>
                                                <span className='description-percentage text-primary'>
                                                    <i className={globalSettings?.icons?.voteYea}></i>
                                                    {HtmlParser(globalSettings?.html?.space?.formatOne)}
                                                    {/* {!isUndefined(electionDetails) && !isNull(electionDetails) && electionDetails.length > 0 &&
                                                        !isUndefined(electionDetails[0].votesResults) && !isNull(electionDetails[0].votesResults) &&
                                                        !isUndefined(electionDetails[0].votesResults.votesHierarchy) && !isNull(electionDetails[0].votesResults.votesHierarchy) ?
                                                        separatorsNumbersSet(electionDetails[0].votesResults.votesHierarchy, false)?.result :
                                                        separatorsNumbersSet(0, false)?.result */
                                                        separatorsNumbersSet({
                                                            number: !isUndNullEmp({ data: electionDetails, subMethod: currentMethod, })?.result && electionDetails?.length > 0 &&
                                                                !isUndNullEmp({ data: electionDetails?.[0]?.votesResults?.votesHierarchy, subMethod: currentMethod, })?.result ? electionDetails?.[0]?.votesResults?.votesHierarchy : 0,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: currentMethod,
                                                        })?.result
                                                    }
                                                </span>
                                                <h5 className='description-header'>---</h5>
                                                <span className='description-text'>{globalSettings?.labels?.totalVotes?.[languageObj?.id]}</span>
                                            </div>

                                        </div>

                                        <div className='col-sm-3 col-6'>
                                            <div className='description-block border-right'>
                                                <span className='description-percentage text-success'>
                                                    <i className={globalSettings?.icons?.checkCircle}></i>
                                                    {HtmlParser(globalSettings?.html?.space?.formatOne)}
                                                    {/* {!isUndefined(electionDetails) && !isNull(electionDetails) && electionDetails.length > 0 &&
                                                        !isUndefined(electionDetails[0].votesResults) && !isNull(electionDetails[0].votesResults) &&
                                                        !isUndefined(electionDetails[0].votesResults.votesComplete) && !isNull(electionDetails[0].votesResults.votesComplete) ?
                                                        separatorsNumbersSet(electionDetails[0].votesResults.votesComplete, false)?.result :
                                                        separatorsNumbersSet(0, false)?.result */
                                                        separatorsNumbersSet({
                                                            number: !isUndNullEmp({ data: electionDetails, subMethod: currentMethod, })?.result && electionDetails?.length > 0 &&
                                                                !isUndNullEmp({ data: electionDetails?.[0]?.votesResults?.votesComplete, subMethod: currentMethod, })?.result ? electionDetails?.[0]?.votesResults?.votesComplete : 0,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: currentMethod,
                                                        })?.result
                                                    }
                                                </span>
                                                <h5 className='description-header'>---</h5>
                                                <span className='description-text'>{globalSettings?.labels?.fullVotes?.[languageObj?.id]}</span>
                                            </div>

                                        </div>

                                        <div className='col-sm-3 col-6'>
                                            <div className='description-block border-right'>
                                                <span className='description-percentage text-warning'>
                                                    <i className={globalSettings?.icons?.warningTrinagle}></i>
                                                    {HtmlParser(globalSettings?.html?.space?.formatOne)}
                                                    {/*!isUndefined(electionDetails) && !isNull(electionDetails) && electionDetails.length > 0 &&
                                                        !isUndefined(electionDetails[0].votesResults) && !isNull(electionDetails[0].votesResults) &&
                                                        !isUndefined(electionDetails[0].votesResults.votesPartial) && !isNull(electionDetails[0].votesResults.votesPartial) ?
                                                        separatorsNumbersSet(electionDetails[0].votesResults.votesPartial, false)?.result :
                                                        separatorsNumbersSet(0, false)?.result*/
                                                        separatorsNumbersSet({
                                                            number: !isUndNullEmp({ data: electionDetails, subMethod: currentMethod, })?.result && electionDetails?.length > 0 &&
                                                                !isUndNullEmp({ data: electionDetails?.[0]?.votesResults?.votesPartial, subMethod: currentMethod, })?.result ? electionDetails?.[0]?.votesResults?.votesPartial : 0,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: currentMethod,
                                                        })?.result
                                                    }
                                                </span>
                                                <h5 className='description-header'>---</h5>
                                                <span className='description-text'>{globalSettings?.labels?.partialVotes?.[languageObj?.id]}</span>
                                            </div>

                                        </div>

                                        <div className='col-sm-3 col-6'>
                                            <div className='description-block'>
                                                <span className='description-percentage text-secondary'>
                                                    <i className={globalSettings?.icons?.stickyNote}></i>
                                                    {HtmlParser(globalSettings?.html?.space?.formatOne)}
                                                    {/*!isUndefined(electionDetails) && !isNull(electionDetails) && electionDetails.length > 0 &&
                                                        !isUndefined(electionDetails[0].votesResults) && !isNull(electionDetails[0].votesResults) &&
                                                        !isUndefined(electionDetails[0].votesResults.votesNull) && !isNull(electionDetails[0].votesResults.votesNull) ?
                                                        separatorsNumbersSet(electionDetails[0].votesResults.votesNull, false)?.result :
                                                        separatorsNumbersSet(0, false)?.result*/
                                                        separatorsNumbersSet({
                                                            number: !isUndNullEmp({ data: electionDetails, subMethod: currentMethod, })?.result && electionDetails?.length > 0 &&
                                                                !isUndNullEmp({ data: electionDetails?.[0]?.votesResults?.votesNull, subMethod: currentMethod, })?.result ? electionDetails?.[0]?.votesResults?.votesNull : 0,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: currentMethod,
                                                        })?.result
                                                    }
                                                </span>
                                                <h5 className='description-header'>---</h5>
                                                <span className='description-text'>{globalSettings?.labels?.invalidVotes?.[languageObj?.id]}</span>
                                            </div>

                                        </div>
                                    </div>
                                    {/* /.row */}

                                    <div className='row'>
                                        <div className='col-12'>
                                            <hr style={{ height: '0.5' }} />
                                        </div>
                                    </div>

                                    <div className='row text-center' style={{ fontSize: 12 }}>
                                        <div className='col-sm-3 text-muted'>
                                            {`${globalSettings?.app?.company?.name} `}
                                        </div>
                                        <div className='col-sm-3 text-muted'>
                                            {`${globalSettings?.app?.company?.slogan}`}
                                        </div>
                                        <div className='col-sm-3 text-muted'>
                                            {`${globalSettings?.app?.company?.url}`}
                                        </div>
                                        <div className='col-sm-3 text-muted'>
                                            {`${globalSettings?.app?.name} / ${globalSettings?.app?.version} / ${globalSettings?.app?.year}`}
                                        </div>
                                    </div>

                                </section>

                            </div>
                        </div>
                    </div>
                    :
                    //#region old code
                    // <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                    //     width={50}
                    //     height={50}
                    //     color={globalSettings?.colors?.infoColorExp}
                    //     msgText={globalSettings?.messages?.processing?.[languageObj?.id]}
                    //     msgOrientation='text-center'
                    //     msgTextMuted={true}/>
                    //#endregion old code
                    <div className='text-center'
                        style={{ paddingTop: '50px', }}>
                        <LoadingSection alt='loadingSection'
                            className={globalSettings?.react?.html?.overlay?.textMued}
                            //className='overlay text-muted'
                            showText={true}
                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                            height={25}
                            hidden={!showLoading}
                            languageId={languageObj?.id}
                            width={25}
                            subMethod={currentMethod} />
                    </div>

            }

            {/* </div> */}
        </div>
    )
}